import React from "react";
import PropTypes from "prop-types";
import { YesNoToggle as SharedYesNoToggle } from "shared/YesNoToggle";

export function YesNoToggle({ value, onChange, label }) {
  return <SharedYesNoToggle value={value} onChange={onChange} label={label} />;
}

YesNoToggle.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};
